import { CLIENTS } from "../data/content";

export default function ClientMarquee() {
  // Duplicate list for seamless loop
  const list = [...CLIENTS, ...CLIENTS];
  return (
    <section className="py-12 border-y border-white/5 bg-[#0c0c0c]" data-testid="client-marquee">
      <div className="yv-container">
        <p className="yv-eyebrow text-center mb-6">Over 1,000 videos produced for clients including</p>
        <div className="overflow-hidden max-w-3xl mx-auto">
          <div className="yv-marquee">
            {list.map((c, i) => (
              <img key={`${c.name}-${i}`} src={c.logo} alt={c.name} loading="lazy" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
